import React, { useState } from 'react';
import Dashboard from './components/Dashboard/Dashboard';
import Login from './components/Login/Login';
import AdminPanel from './components/AdminPanel/AdminPanel';
import ConfigPanel from './components/ConfigPanel/ConfigPanel';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// 📝 Importar sistema de logging para debugging
import './utils/testLogger';

function App() {
  const [view, setView] = useState('Login');
  const [user, setUser] = useState(null);

  const handleNavigate = (target) => {
    setView(target);
  };

  const handleLoginSuccess = (loggedUser) => {
    setUser(loggedUser);
    setView('dashboard');
  };

  const handleLogout = () => {
    setUser(null);
    setView('Login');
  };

  return (
    <>
      {view === 'Login' && (
        <Login
          onNavigate={handleNavigate}
          onLoginSuccess={handleLoginSuccess}
        />
      )}
      {view === 'dashboard' && (
        <Dashboard
          onNavigate={handleNavigate}
          onLogout={handleLogout}
          user={user}
        />
      )}
      {view === 'admin' && (
        <AdminPanel
          onNavigate={handleNavigate}
          onLogout={handleLogout}
          user={user}
        />
      )}
      {view === 'config' && (
        <ConfigPanel
          onNavigate={handleNavigate}
          onLogout={handleLogout}
          user={user}
        />
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default App;
